import { $ppidAtom } from '@client/core/atoms/config.js';
import fetcher from '@client/core/utils/api/fetcher.js';

const sessionId = crypto.randomUUID();

let visitorId: string | null = null;
const getVisitorId = () => {
  if (!visitorId) {
    const ppidData = $ppidAtom.get();
    visitorId =
      ppidData.martailer?.ppId1 || ppidData.martailer?.ppId2 || 'anonymous';
  }
  return visitorId;
};

export type MartailerPayload = {
  placement: string;
  visitorId?: string;
  store: string;
  sponsoredProductsCount?: number;
  sponsoredListingsCount?: number;
  searchTerm?: string;
  categories?: string[];
  sessionId?: string;
  requestId?: string;
};

export type MartailerResponse = {
  sponsoredListings?: Array<MartailerProduct>; // Define proper type based on API response
  sponsoredProducts?: Array<MartailerProduct>;
};

export type MartailerProduct = {
  adId: string;
  link: string;
  price: number;
  title: string;
  brand: string;
  position: number;
  itemId: string;
  categories: string;
  imageLink: string;
  organisationId: number;
  organisationName: string;
};

export type MartailerImpressionPayload = {
  adId: string;
  itemId: string;
  placement: string;
  visitorId?: string; // Add ?
  categories: string;
  store: string;
  searchTerm?: string;
  sessionId?: string;
};

export type MartailerClickPayload = {
  adId: string;
  itemId: string;
  placement: string;
  visitorId?: string; // Add ?
  categories: string;
  store: string;
  searchTerm?: string;
  sessionId?: string;
};

export async function callMartailerApi(
  payload: MartailerPayload
): Promise<MartailerResponse> {
  return fetcher<MartailerResponse>('/api/martailer/sponsored-catalog', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      ...payload,
      sessionId,
      visitorId: getVisitorId(),
      device: {
        deviceType: 'desktop',
        userAgent: navigator.userAgent
      }
    })
  });
}

export async function trackMartailerImpression(
  payload: MartailerImpressionPayload
): Promise<void> {
  try {
    await fetcher('/api/martailer/impression', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        event: 'impression',
        ...payload,
        sessionId,
        visitorId: getVisitorId(),
        userAgent: navigator.userAgent
      })
    });
  } catch (error) {
    console.error('Failed to track impression:', error);
  }
}

export async function trackMartailerClick(
  payload: MartailerClickPayload
): Promise<void> {
  try {
    await fetcher('/api/martailer/click', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        event: 'click',
        ...payload,
        sessionId,
        visitorId: getVisitorId(),
        pageUrl: window.location.href,
        userAgent: navigator.userAgent
      })
    });
  } catch (error) {
    console.error('Failed to track click:', error);
  }
}
